import { render, staticRenderFns } from "./AdminMalla.vue?vue&type=template&id=7fc5b210&"
import script from "./AdminMalla.vue?vue&type=script&lang=js&"
export * from "./AdminMalla.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports